// utils/planesUtils.js
export const toNumber = (v, def = 0) => {
  const n = parseFloat(v);
  return isFinite(n) ? n : def;
};

export const isEmptyObject = (v) => v && typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length === 0;

export const firstDefined = function () {
  for (var i = 0; i < arguments.length; i++) {
    if (arguments[i] !== null && arguments[i] !== undefined) return arguments[i];
  }
  return '';
};

export const sumByPrima = (lista) => (Array.isArray(lista) ? lista : []).reduce((sum, it) => sum + toNumber(it.prima), 0);

/** Clave estándar para comparar coberturas: cod_riesgo si existe, si no nombre */
export const coverageKey = (c) => {
  if (!c) return '';
  const raw = (c.cod_riesgo ? c.cod_riesgo : c.nombre ? c.nombre : '').toString();
  return raw.trim().toLowerCase();
};

/** True si son la misma cobertura (misma key) */
export const sameCoverageKey = (a, b) => {
  const ka = coverageKey(a);
  const kb = coverageKey(b);
  return ka !== '' && ka === kb;
};

/** Construye opciones {value,label,...extra} para selects a partir de API */
export const mapOptions = (items, valueKeys = ['value', 'codigo', 'cod_riesgo'], labelKeys = ['label', 'nombre']) => {
  if (!Array.isArray(items)) return [];
  return items.map((it) => {
    const rawValue = firstDefined(...valueKeys.map(k => it && it[k]));
    const rawLabel = firstDefined(...labelKeys.map(k => it && it[k]));
    const v = String(rawValue);
    const l = String(rawLabel);
    return {
      value: v,
      label: l,
      codigo: it && (it.codigo || v),
      cod_riesgo: it && (it.cod_riesgo || v),
      nombre: it && (it.nombre || l),
      deducible: it && it.deducible
    };
  });
};

export const formatTasa = (tasaValue) => {
  if (tasaValue === '' || tasaValue === null || tasaValue === undefined) return '';
  const num = Number(tasaValue);
  if (isNaN(num)) return String(tasaValue);
  // Evitar notación científica usando toFixed y removiendo ceros a la derecha
  return num.toFixed(10).replace(/\.?0+$/, '');
};

export const calcTasa = (prima, suma) => {
  const p = toNumber(prima, NaN);
  const s = toNumber(suma, NaN);
  if (!isFinite(p) || !isFinite(s) || s <= 0) return '';
  const val = (p / s) * 1000;
  // Evitar notación científica y mantener precisión para tasas pequeñas
  return val.toFixed(10).replace(/\.?0+$/, '');
};

